export default __webpack_public_path__ + "static/media/118.bb2f5414.gif";